import cx from "classnames";
import React from "react";

import styles from "./SlapshotSwitch.module.scss";

export interface SlapshotSwitchProps {
  id: string;
  checked: boolean;
  onChange: () => void;
  containerClassName?: string;
  inputClassName?: string;
  labelClassName?: string;
}

const SlapshotSwitch: React.FC<SlapshotSwitchProps> = ({
  id,
  checked,
  onChange,
  containerClassName,
  inputClassName,
  labelClassName,
}) => {
  return (
    <div className={cx(styles.switchContainer, containerClassName)}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        className={cx(styles.input, inputClassName)}
        onChange={() => {
          onChange();
        }}
      />
      <label htmlFor={id} className={cx(styles.label, labelClassName)} />
    </div>
  );
};

export default SlapshotSwitch;
